import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useRef } from 'react';

export const AbvMcdLiabPerspective = ({ overUnderScenId }) => {
  const entityPerspectiveRef = useRef();

  const views = [
    {
      name: 'Payments',
      dims: ['OVER_UNDER_SCEN', 'EARNED_PERIOD', 'PROG', 'STATE', 'PROD'],
      kpis: [
        'PYMT_AMT',
        'PYMT_ADJ',
        'TOTAL_PYMT',
        'CALC_LIAB',
        'FORECASTED_LIAB_ADJ',
        'TOTAL_FORECASTED_LIAB',
        'LIAB_ADJ',
        'PROJ_PYMT_AMT',
      ],
      disabledDims: ['OVER_UNDER_SCEN'],
      numFrozenDims: 1,
      dimToPeriodicities: {
        EARNED_PERIOD: ['YEAR', 'QTR'],
      },
    },
  ];

  const defaultDimFilters = { OVER_UNDER_SCEN: [overUnderScenId] };

  // Add context menu entries for payment transaction details
  const getContextMenuItems = (params) => {
    let contextMenus = entityPerspectiveRef.current.getContextMenuItems(params);

    const pymtItems = [
      {
        name: 'Payment Amounts',
        action: () =>
          entityPerspectiveRef.current.navigateToViewer(
            params,
            'PYMT_AMT',
            'Payment Amounts',
            'MCD_LIAB_VIEWER_PLUGIN',
          ),
        icon: fas.faListUl,
      },
      {
        name: 'Payment Adjustments',
        action: () =>
          entityPerspectiveRef.current.navigateToViewer(
            params,
            'PYMT_ADJ',
            'Payment Adjustments',
            'MCD_LIAB_VIEWER_PLUGIN',
          ),
        icon: fas.faListUl,
      },
    ];

    const adjItems = [
      {
        name: 'Forecasted Liability Adjustment Details',
        action: () =>
          entityPerspectiveRef.current.navigateToPerspectiveAdj(
            params,
            'FORECASTED_LIAB_ADJ',
            'Forecasted Liability Adjustment Details',
          ),
        icon: fas.faListUl,
      },
      {
        name: 'Liability Adjustment Details',
        action: () =>
          entityPerspectiveRef.current.navigateToPerspectiveAdj(params, 'LIAB_ADJ', 'Liability Adjustment Details'),
        icon: fas.faListUl,
      },
    ];

    // Only show "Calculate Liability" at the OVER_UNDER_SCEN dimension to ensure that the user has all necessary filters applied before performing the calculation
    if (params.node.data.dim === 'OVER_UNDER_SCEN') {
      contextMenus.push({
        name: 'Calculate Liability',
        action: () =>
          entityPerspectiveRef.current.openActionDialog(params, 'Calculate Liability', 'MCD_LIAB_CALC_ACTION_PLUGIN'),
        icon: fas.faCalculator,
      });
    }

    contextMenus.push(
      {
        name: 'Adjust Forecasted Liability',
        action: () => entityPerspectiveRef.current.overwrite(params, 'FORECASTED_LIAB_ADJ'),
        icon: fas.faPencil,
      },
      {
        name: 'Adjust Liability',
        action: () => entityPerspectiveRef.current.overwrite(params, 'LIAB_ADJ'),
        icon: fas.faPencil,
      },
      {
        name: 'Payment Transaction Details',
        subMenu: pymtItems,
        icon: fas.faListUl,
      },
      {
        name: 'Adjustment Details',
        subMenu: adjItems,
        icon: fas.faListUl,
      },
    );

    return contextMenus;
  };

  return (
    <EntityPerspective
      ref={entityPerspectiveRef}
      views={views}
      defaultDimFilters={defaultDimFilters}
      entity={'MCD_LIAB'}
      gridOptions={{
        getContextMenuItems,
      }}
    />
  );
};
